module.exports = __webpack_public_path__ + "static/media/arrow_right_square.cec99238.svg";